var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidemanagerimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8848 35.9253C12.3911 34.3943 13.3674 33.0619 14.6746 32.1177C15.9819 31.1735 17.5536 30.6655 19.1662 30.666H26.8329C28.4444 30.6655 30.0152 31.1728 31.322 32.1159C32.6287 33.059 33.6051 34.3899 34.1124 35.9196M22.9995 24.916C24.5245 24.916 25.987 24.3102 27.0654 23.2319C28.1437 22.1535 28.7495 20.691 28.7495 19.166C28.7495 17.641 28.1437 16.1785 27.0654 15.1002C25.987 14.0218 24.5245 13.416 22.9995 13.416C21.4745 13.416 20.012 14.0218 18.9337 15.1002C17.8553 16.1785 17.2495 17.641 17.2495 19.166C17.2495 20.691 17.8553 22.1535 18.9337 23.2319C20.012 24.3102 21.4745 24.916 22.9995 24.916Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0938 12.0174C39.4354 12.7802 40.2596 14.2081 40.25 15.751V29.712C40.25 31.2626 39.4009 32.6924 38.0305 33.4457L25.093 41.6299C24.4515 41.9818 23.7317 42.1664 23 42.1664C22.2683 42.1664 21.5485 41.9818 20.907 41.6299L7.9695 33.4457C7.29965 33.0785 6.74046 32.5385 6.35012 31.8818C5.95978 31.2252 5.75255 30.4759 5.75 29.712V15.7491C5.75 14.1985 6.59908 12.7706 7.9695 12.0174L20.907 4.38903C21.5674 4.02493 22.3092 3.83398 23.0633 3.83398C23.8173 3.83398 24.5591 4.02493 25.2195 4.38903L38.157 12.0174H38.0938Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidemanagerimg);
export default __webpack_public_path__ + "static/media/sidemanagerimg.c98be5603b12073a27fb27ef1d62e9fe.svg";
export { ForwardRef as ReactComponent };